import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_casal_trader.png",
      alt: "Estratégias Casal Trader",
    },
    title: "Siga minhas operações",

    // String ou array de strings
    text: [
      "O Casal Trader abriu a caixa preta de suas operações, superar as metas sem colocar o capital em risco é fundamental para ser lucrativo todos os meses. Vivemos o Skin the Game e sabemos que operações sem risco calculado são a ponte para o fracasso!",
      "Nossas operações são todas feitas analisando o risco e sempre mensurando o impacto que pode ter no capital global! Não corra riscos desnecessários, proteja sempre seu capital!",
    ],
    testimonial: {
      text: "Risco é o combustível do Trader, mas se não for calculado será a sua derrota!",
      author: {
        name: "Mário Vilas Boas, Analista CNPI-T 2817",
        picture: "",
      },
    },
  },

  strategies: {
    title: "Copy Trade do Casal",
    heading: "Copie nossas operações direto em sua conta.",
    subtitle:
      "Veja seu capital crescer de forma automatizada porém com o olhar crítico de um um analista CNPI! Comece agora mesmo a ser lucrativo!",
  },

  cta: {
    title: "Venha fazer parte do nosso time!",
    subtitle: "Comece com o copy trade do casal.",
  },

  about: {
    title: "Sobre o analista",
    subtitle: "O CasalTrader",
    col1: [
      "O Casal Trader, formado por Mário Vilas Boas e Eliete Amorim é a união da razão e da emoção, e como em qualquer casal de sucesso é a soma das qualidades de cada um para formar um time vencedor!",
      "O casal vive o trade na pele, no chamado Skin in the Game! Estamos 100% dedicados ao mercado e dele vivemos!",
    ],
    col2: [
      "Mário é Analista CNPI com foco em Day Trade enquanto Eliete como especialista em Mercado de Capitais pela FGV tem a visão macro e sistêmica do mercado como um todo!",
      "Agora você pode compartilhar toda a experiência e conhecimento adquirido pelo casal ao longo dos anos, você terá acesso às estratégias do casal em tempo real.",
    ],
  },

  stats: {
    title: "Veja o Casal em Números",
    subtitle: "Mais de 5 anos de experiência de mercado.",
    data: [
      {
        value: "+5",
        description: "Anos de experiência",
      },
      {
        value: "+90",
        description: "Ativos analisados",
      },
      {
        value: "1",
        description: "Analista CNPI",
      },
    ],
  },

  features: {
    title: "Por que seguir as estratégias do Casal Trader?",
    subtitle:
      "Veja quais as principais vantagens das estratégias do Casal Trader.",
    data: [...defaultContent.features.data],
  },

  plans: {
    title: "Planos",
    subtitle:
      "Conheça os planos do Casal Trader e veja qual se adequa melhor ao seu perfil.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
